import { useQueryClient } from '@tanstack/react-query';
import React from 'react'
import { Link } from 'react-router-dom'
import { updateTapCount } from '../../../helpers/tapCountMutation';

function ReviewCardStd({ reviews, preview, Textcolor, BtIColor }) {

    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button, id) => {
        // console.log("iiii", id);

        updateTapCount(queryClient, button, id);
    };

    return (
        <div>
            {reviews?.map((review) => (
                <div className="social-media2 relative">
                    <svg width="13" className="absolute right-5  top-1/2 transform -translate-y-1/2 " height="13" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L1 9" stroke={BtIColor || "#888888"} stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    
                    <Link
                        onClick={() => handleTap('reviews', review._id)}
                        to={review?.reviewUrl}
                        target={`${preview ? "_blank" : ""}`}
                        className=""
                    >
                        <div className='flex justify-start items-center px-2'>
                        <div className="">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.99914 20.4951L12.0008 17.3209L17.0024 20.5368L15.6925 14.5226L20.0987 10.5132L14.3031 9.97021L12.0008 4.29013L9.69845 9.92844L3.90288 10.4714L8.3091 14.5226L6.99914 20.4951ZM4.5777 24L6.54661 15.124L0 9.15662L8.62349 8.37143L12.0008 0L15.3781 8.36976L24 9.15495L17.4534 15.1224L19.4239 23.9983L12.0008 19.2872L4.5777 24Z"    fill={BtIColor ? BtIColor : "black"}/>
</svg></div>
                        <h5 
                            style={{
                                color: `${Textcolor ? Textcolor : ""}`,
                                fontSize:"12px",
                                fontWeight:"500"
                            }}
                        >
                            {review?.reviewName ? review?.reviewName : ""}
                        </h5></div>
                    </Link>
                    {/* <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} /> */}
                </div>
            ))}
        </div>
    )
}

export default ReviewCardStd